function openAccordion(Index, accordion) {
    var index0 = parseInt(Index);
    accordion.closest(".horizontal-accordion").querySelectorAll(".horizontal-text").forEach(function (h, index) {
        if (index0 == index) {
            h.classList.remove("hide_tab");
        } else {
            h.classList.add("hide_tab")
        }
    });

    accordion.parentElement.querySelectorAll(".horizontal-heading").forEach(function (h, index) {
        if (index0 == index) {
            h.classList.add("active");
        } else {
            h.classList.remove("active")
        }
    });
}